// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jdnB","content":"styles_content__1IK8c","row":"styles_row__LDYko","footer":"styles_footer__39JRA","phraseLength":"styles_phraseLength__3iQGa"};